<template>
    <div class="surveillance" :style="videoFull ? 'z-index:9999' : ''">
        <Title chineseTitle="安防监控" englishTitle="Surveillance video" />
        <div class="surveillanceContent" :class="{ videoFull }" v-if="$store.state.surveillance.length">

            <!-- 名称 -->
            <div class="title row-center" @click="showList = !showList" v-show="!videoFull">
                <img src="@/assets/img/change.png" alt="" />
                <span>
                    {{ 
                        $store.getters.getRooms(this.areaId).details[currentType][currentDetails] ? $store.getters.getRooms(this.areaId).details[currentType][currentDetails].device_name : currentType === 0 ? "无监控数据": "无门禁数据"
                    }}
                </span>
            </div>

            <div class="list" v-show="showList && !videoFull">
                <img class="close" @click="showList = false" src="@/assets/img/close.png" alt="关闭" />
                <!-- 类型 -->
                <div class="type row-center">
                    <span v-for="(type, index) in $store.getters.getRooms(this.areaId).types" :class="{ active: index === currentType }" :key="index"
                        @click="currentType = index">
                        {{ type }}
                    </span>
                </div>
                <!-- 列表 -->
                <div class="names">
                    <span v-if="$store.getters.getRooms(this.areaId).details[currentType].length < 1">暂无数据</span>
                    <span v-for="(item, index) in $store.getters.getRooms(this.areaId).details[currentType]"
                        :class="{ active: currentDetails === index }" :key="index"
                        @click.stop="postMonitorMessage(index)">
                        {{ item.device_name }}
                    </span>
                </div>
            </div>

            <!-- 详细信息 -->
            <div class="video" v-if="$store.getters.getRooms(this.areaId).details[currentType][currentDetails]">
                <iframe
                    :src="'https://www.energydt.cn/proxy/webrtc/index.html?' + JSON.parse($store.getters.getRooms(this.areaId).details[currentType][currentDetails].device_details).roomName"
                    frameborder="0">
                </iframe>
            </div>

            <div class="video column-center" v-else>
                <img src="@/assets/img/加载视频.png" alt="" />
                <span v-if="currentType === 0">视频监控</span>
                <span v-else>无门禁数据</span>
            </div>

            <!-- 全屏按钮 -->
            <div class="btn row-center" v-if="!videoFull" @click="full">
                <img src="@/assets/img/fullScreen.png" alt="全屏" />
                <span>全屏</span>
            </div>
            <div class="btn row-center" v-else @click="cancelFull">
                <img src="@/assets/img/full_cancel.png" alt="取消全屏" />
                <span>取消全屏</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title.vue";

    export default {
        name: "Home",
        components: {
            Title,
        },
        props: ["areaId", "cType", "cDetails", "iframeWin"],
        data() {
            return {
                videoFull: false,
                currentType: this.cType || 0,
                currentDetails: this.cDetails || 0,
                showList: false,
            };
        },
        watch: {
            cDetails(newVal, oldVal) {
                this.currentDetails = newVal
            }
        },
        methods: {
            postMonitorMessage(index) {
                this.currentDetails = index;
                this.iframeWin && this.iframeWin.postMessage({
                        cmd: 'monitor',
                        data: index,
                    },
                    "*"
                );
            },
            cancelFull() {
                this.videoFull = false;
            },
            full() {
                this.videoFull = true;
            },
        },
    };
</script>

<style lang="less" scoped>
    .list {
        width: 100%;
        height: 100%;
        position: absolute;
        left: -4080/192vw;
        top: 0;
        color: #ffffff;
        font-size: 18rem;
        background-image: url("../../assets/img/安防列表.png");
        background-size: 100% 100%;
        padding-top: 230/108vh;
        padding-left: 240/192vw;
        padding-right: 180/192vw;

        .close {
            position: absolute;
            top: 230/108vh;
            right: 200/192vw;
            width: 190/192vw;
            height: 180/108vh;
            cursor: pointer;
        }

        .active {
            color: #0d94ff;
        }

        .names {
            height: 70%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            overflow-y: auto;

            span {
                margin-bottom: 230/108vh;
                cursor: pointer;
            }
        }

        .type {
            justify-content: flex-start;
            border-bottom: 1px solid rgba(255, 255, 255, 0.75);
            margin-bottom: 160/108vh;

            span {
                margin-right: 330/192vw;
                margin-bottom: 130/108vh;
                cursor: pointer;
            }
        }
    }

    .videoFull {
        position: fixed !important;
        left: 0 !important;
        top: 72 * 100 / 1080vh !important;
        width: 100vw !important;
        height: 100 - 72 * 100 /1080vh !important;
        margin: 0 !important;
        padding: 0 !important;
        background: #000 !important;

        .video {
            width: 100% !important;
            height: 100% !important;
            top: 0 !important;
        }

        .btn {
            position: fixed !important;
            top: 94vh !important;
            right: 2vw !important;
            cursor: pointer;
        }
    }



    .surveillance {
        position: fixed;
        top: 3130/108vh;
        left: 14600/192vw;
    }

    .surveillanceContent {
        width: 4000/192vw;
        height: 3000/108vh;
        background: rgba(3, 13, 24, 0.75);
        margin-left: 1vw;
        position: relative;

        .btn {
            .wh(12, 16);
            position: absolute;
            top: @h;
            right: @w;
            z-index: 99999;
            color: #ffffff;
            font-size: 18rem;
            cursor: pointer;

            img {
                .wh(16, 16);
                width: @w;
                height: @h;
                margin-right: 7 / 1920 * 100vw;
            }
        }

        .video {
            width: 376 / 1920 * 100vw;
            height: 242 / 1080 * 100vh;
            position: absolute;
            left: 120/192vw;
            top: 460/108vh;
            color: #ffffff;

            span {
                margin-top: 300/108vh;
                font-size: 14rem;
            }

            iframe {
                width: 100%;
                height: 100%;
            }
        }

        .title {
            position: absolute;
            left: 120/192vw;
            top: 160/108vh;
            font-size: 18rem;
            color: #e6f3fd;
            height: 24 / 1080 * 100vh;
            cursor: pointer;

            img {
                margin-right: 110/192vw;
                width: 160/192vw;
                height: 130/108vh;
            }
        }
    }

    .names::-webkit-scrollbar {
        width: 50/192vw;
        height: 1px;
    }

    .names::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    // .names::-webkit-scrollbar-track {
    //     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    //     border-radius: 10px;
    //     background: #111;
    // }
</style>